<footer class="footer">
    <div class="footer-content">
      <div class="logo ecoenvai-logo">
        <a href="https://ecoenvai.ijs.si" target="_blank" rel="noopener noreferrer">
            <img src="assets/mag-landing/ecoenvai-logo.png" alt="EcoEnVAi Logo" />
        </a>
      </div>
      <div class="logo jsi-logo">
        <a href="https://www.ijs.si" target="_blank" rel="noopener noreferrer">
            <img src="assets/ijs_logo.png" alt="Jožef Stefan Institute Logo" />
        </a>
      </div>
      <div class="logo radiant-logo">
        <a href="https://www.radiantproject.eu/" target="_blank" rel="noopener noreferrer">
            <img src="assets/logo-no background-radiant.png" alt="Radiant Project Logo" />
        </a>
      </div>
      <div class="logo eu-logo">
        <a href="https://cordis.europa.eu/project/id/101000622" target="_blank" rel="noopener noreferrer">
            <img src="assets/EN_Co-fundedbytheEU_RGB_POS@2x.png" alt="EU Co-funded Logo" />
        </a>
      </div>
    </div>
    <div class="footer-text">
        Web tool developed by the 
        <a href="https://ecoenvai.ijs.si" class="link" target="_blank" rel="noopener noreferrer">
            EcoEnvAI
        </a> team at the 
        <a href="https://www.ijs.si" class="link" target="_blank" rel="noopener noreferrer">
            Jožef Stefan Institute
        </a> in Ljubljana, Slovenia. This tool is in beta.
    </div>      
</footer>
  